import generateCalendar from 'antd/es/calendar/generateCalendar';
import dayJsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import 'antd/es/calendar/style';
import { Dayjs } from '@lgg/isomorphic/dayjs';

const Calendar = generateCalendar<Dayjs>(dayJsGenerateConfig);

export default Calendar;
